export const sliderItems = [
    {
      id: 1,
      img: "https://i.ibb.co/9sM8jXr/woman-with-shopping-bags-studio-yellow-background-isolated-1303-14294-removebg-preview.png",
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://i.ibb.co/6nSGH6t/radu-florin-OP8655xg-Bjo-unsplash-removebg-preview.png",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://i.ibb.co/cXFnLLV/3.png",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/3345882/pexels-photo-3345882.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      title: "GADGETS!",
      cat:"Electronics"
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/3812433/pexels-photo-3812433.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      title: "SHIRTS LOVE",
      cat:"shirt"
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/16170/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "LIGHT JACKETS",
      cat:"coat"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"http://pngimg.com/uploads/coat/small/coat_PNG58.png",
    },
    {
      id:2,
      img:"http://pngimg.com/uploads/dress_shirt/dress_shirt_PNG8117.png",
    },
    {
      id:3,
      img:"http://pngimg.com/uploads/tshirt/tshirt_PNG5444.png",
    },
    {
      id:4,
      img:"http://pngimg.com/uploads/sweater/sweater_PNG64.png",
    },
    {
      id:5,
      img:"http://pngimg.com/uploads/macbook/macbook_PNG76.png",
    },
    {
      id:6,
      img:"http://pngimg.com/uploads/photo_camera/photo_camera_PNG101643.png",
    },
    {
      id:7,
      img:"http://pngimg.com/uploads/men_shoes/men_shoes_PNG7476.png",
    },
    {
      id:8,
      img:"http://pngimg.com/uploads/watches/watches_PNG101449.png",
    },
  ]